module.exports = __webpack_public_path__ + "img/nearby.bb836917.svg";